import { Record } from 'immutable';

export default class CustomerFortnoxSettingRecord extends Record({
  id: undefined,
  staffingCompany: undefined,
  fortnoxId: undefined,
}) {
}
